(function(){
  function labelFor(select){
    const opt = select.options[select.selectedIndex];
    return opt ? opt.textContent.trim() : 'Select option';
  }
  function enhance(select){
    if(!select || select.dataset.udEnhanced === 'true') return;
    if(select.multiple) return;
    if(select.matches('[data-ud-option-select], [data-ud-addon-option]')) return;
    if(select.closest('[data-option-ui="pills"] [data-ud-option-row], [data-ud-addon-options]')) return;
    select.dataset.udEnhanced = 'true';
    select.classList.add('ud-native-hidden');
    const wrap = document.createElement('div');
    wrap.className = 'ud-select-wrap';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ud-select-button';
    btn.textContent = labelFor(select);
    const list = document.createElement('div');
    list.className = 'ud-select-list';
    wrap.appendChild(btn);
    wrap.appendChild(list);
    select.insertAdjacentElement('afterend', wrap);

    function render(){
      btn.textContent = labelFor(select);
      list.innerHTML = '';
      Array.from(select.options).forEach(opt => {
        const item = document.createElement('button');
        item.type = 'button';
        item.className = 'ud-select-option';
        if(opt.selected) item.classList.add('is-selected');
        if(opt.disabled) item.classList.add('is-disabled');
        item.textContent = opt.textContent;
        item.dataset.value = opt.value;
        item.addEventListener('click', () => {
          if(opt.disabled) return;
          select.value = opt.value;
          select.dispatchEvent(new Event('change', {bubbles:true}));
          wrap.classList.remove('is-open');
          render();
        });
        list.appendChild(item);
      });
    }
    btn.addEventListener('click', e => {
      e.preventDefault();
      document.querySelectorAll('.ud-select-wrap.is-open').forEach(w => { if(w !== wrap) w.classList.remove('is-open'); });
      wrap.classList.toggle('is-open');
    });
    select.addEventListener('change', render);
    new MutationObserver(render).observe(select, {childList:true, subtree:true, attributes:true});
    render();
  }
  function init(){ document.querySelectorAll('select:not([data-ud-native])').forEach(enhance); }
  document.addEventListener('click', e => { if(!e.target.closest('.ud-select-wrap')) document.querySelectorAll('.ud-select-wrap.is-open').forEach(w => w.classList.remove('is-open')); });
  document.addEventListener('keydown', e => { if(e.key === 'Escape') document.querySelectorAll('.ud-select-wrap.is-open').forEach(w => w.classList.remove('is-open')); });
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
